import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { graphql, useStaticQuery } from "gatsby"
import React, { useState } from "react"
import SubscriptionForm2 from "./forms/subscriptionForm2"

const Faq = () => {
    const result = useStaticQuery(graphql`
        query QAData {
            allQaJson {
                nodes {
                    answer
                    id
                    question
                }
            }
        }
    `)
    const qa = result.allQaJson.nodes

    const SingleQA = ({ question, answer, id }) => {
        const [ariaExpanded, setAriaExpanded] = useState(true)

        return (
            <div className={`mt-3 card card-faq ${ariaExpanded ? "" : "open"}`}>
                <div className="card-body">
                    <div className="d-flex align-items-center">
                        <div className={`faq-header ${ariaExpanded ? "" : "open"}`}>{question}</div>
                        <div className="ms-auto">
                            <FontAwesomeIcon
                                className={`fa-lg text-purple ms-2 ${ariaExpanded ? "collapsed" : ""}`}
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target={`#faq1__${id}`}
                                aria-expanded={ariaExpanded}
                                aria-controls={`faq1__${id}`}
                                onClick={() => setAriaExpanded(!ariaExpanded)}
                                icon={`fa-regular ${ariaExpanded ? "fa-circle-plus" : "fa-circle-minus"}`}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div className="collapse" id={`faq1__${id}`}>
                                <div className="row">
                                    <div className="col">
                                        <p className="pt-3">{answer}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="container-xxl pb-5 d-flex flex-column align-items-center">
            <h2 className="py-3 py-md-5 text-center mb-0">
                Frequently <br className="d-md-none" /> Asked Questions
            </h2>
            {qa.map(q => (
                <SingleQA key={q.id} {...q} />
            ))}
        </div>
    )
}

export default Faq
